import { styled } from 'styled-components';

export const GalleryPageContainer = styled.div`
  max-width: 1280px;
  padding: ${(props) => props.theme.spacing.spacing10} ${(props) => props.theme.spacing.spacing6};
  margin: 0 auto;
  margin-bottom: ${(props) => props.theme.spacing.spacing10};
`;
